// extracted by mini-css-extract-plugin
export default {"price":"ConfirmServiceCard_price__jCFpq","theme-grayscale":"ConfirmServiceCard_theme-grayscale__n+je2"};